import { styled, Button } from '@mui/material';

export const OutlinedButton = styled(Button)`
  border: 2px solid ${(props) => props.theme.palette.common.cowbellBlue};
  color: ${(props) => props.theme.palette.primary.contrastText};
  -webkit-text-stroke-width: 0.1px;
`;

export const PrimaryButton = styled(Button)`
  background-color: ${(props) => props.theme.palette.common.azureBlue};
  color: ${(props) => props.theme.palette.common.white};
  font-weight: 600;
  font-size: 1.16667rem';
  line-height: 1.33334rem;
  letter-spacing: 1.25px;
  padding: 1rem 1.66667rem;
  width: max-content !important;

  &:hover {
    background-color: ${(props) =>
      props.theme.palette.common.surfaceAction} !important;
  }

  &:disabled {
    user-select: none;
    pointer-events: none;
    background-color: ${(props) => props.theme.palette.common.textBody};
    opacity: 0.75;
  }
`;
